module.exports = __webpack_public_path__ + "static/media/linkedin.23cefbfa.svg";